import React, { Component } from "react";
import PropTypes from "prop-types";

// Packages
import shortid from 'shortid';

class ProfileRatings extends Component {
  static propTypes = {
    ratings: PropTypes.array.isRequired
  }

  getStarRating(numberOfStars) {
    let stars = [];

    for (let i = 0; i < numberOfStars; i++) {
      stars.push(<svg className="star" key={shortid.generate()}><use xlinkHref="#star" /></svg>);
    }

    return stars;
  }

  render() {
    const { ratings } = this.props;

    return (
      <div className="profile-rating">
        {
          ratings.map((rating) => {
            return (
              <div className="star-rating" key={shortid.generate()}>
                <h4>{rating.institution}</h4>
                {this.getStarRating(rating.stars)}
              </div>
            )
          })
        }
      </div>
    );
  }
}

export default ProfileRatings;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileRatings.js